export const getPortalFoods = (API, request, callback) => {
    API.get(`foods`, { params: request }).then(response => {
        callback(response.data);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalFoodDelete = (API, request, callback) => {
    API.delete(`foods/${request.id}`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalAddFood = (API, request, callback) => {
    API.post(`foods`, request).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalUpdateFood = (API, request, callback) => {
    API.put(`foods/${request.id}`, request).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalAddFoodV2 = (API, request, callback) => {
    API.post(`foods/addFood`, request, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalUpdateFoodV2 = (API, request, id, callback) => {
    API.put(`foods/${id}/updateFood`, request, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalUpdateFoodDate = (API, id, callback) => {
    API.put(`foods/updateDate/${id}`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}
